import { BrowserRouter , Switch, Route } from 'react-router-dom';

//Components
import AboutScreen from './Screens/AboutScreen/AboutScreen';
import ShopScreen from './Screens/ShopScreen/ShopScreen';
import ShopItemScreen from './Screens/ShopItemScreen/ShopItemScreen';
import ErrorScreen from './Screens/ErrorScreen/ErrorScreen';
import NotFoundScreen from './Screens/NotFoundScreen/NotFoundScreen';
import ContactScreen from './Screens/ContactScreen/ContactScreen';
import HomeScreen from './Screens/HomeScreen/HomeScreen';
import ShopTypeScreen from './Screens/ShopTypeScreen/ShopTypeScreen';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route exact path='/' component={HomeScreen} />
          <Route exact path='/shop' render={(props) => <ShopScreen {...props} />} />
          <Route exact path='/shop/:itemType' render={(props) => <ShopTypeScreen {...props}/>} />
          <Route path='/shop/:itemType/:itemNumber' render={(props) => <ShopItemScreen {...props} />} />
          <Route path='/about' component={AboutScreen} />
          <Route path='/contact' component={ContactScreen} />
          <Route path='/notfound' component={NotFoundScreen} />
          <Route path='/error' component={ErrorScreen} />
          <Route component={NotFoundScreen} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
